export enum MapSignsDisplayTypes {
  ANALOG = 'analog',
  DIGITAL = 'digital',
}
